export const tableOption = {
  border: true,
  // index: true,
  // indexLabel: '序号',
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  searchShow: false,
  searchBtn: false,
  refreshBtn: false,
  columnBtn: false,
  menu: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  viewBtn: false,
  searchBtn: false,
  header: false,
  column: [{
    label: '数据表',
    prop: 'entityType',
  }, {
    label: '数据ID',
    prop: 'entityId',
  }, {
    label: '操作员',
    prop: 'userId',
  }, {
    label: '操作名称',
    prop: 'actionName',
  }, {
    label: '操作时间',
    prop: 'insertedTime',
    type: 'datetime',
    format: 'yyyy-MM-dd HH:mm',
    valueFormat: 'yyyy-MM-dd HH:mm:ss'
  }, {
    label: '数据',
    prop: 'comments',
    overHidden: true
  }]
}

export const adminActionNameEnum = [
  // Member
  {label: '更新员工信息',value: 0},
  {label: '更新员工状态信息',value: 1},
  {label: '新增官方号信息',value: 2},
  {label: '更新官方号信息',value: 3},
  // {label: '更新管理员员工标签',value: 4},
  // {label: '删除员工',value: 5},
  {label: '导出用户列表',value: 6},
  {label: '确认用户须知',value: 7},
  {label: '查看用户完整手机号',value: 8},
  {label: '导入用户列表',value: 9},

  // Post
  {label: '管理员修改帖子的上下架状态',value: 20},
  {label: '管理员修改帖子的评论状态',value: 21},
  {label: '管理员新增帖子',value: 22},
  {label: '管理员更新帖子',value: 23},
  // {label: '管理员修改帖子的置顶状态',value: 24},
  // {label: '执行检查过期帖子',value: 25},
  {label: '修改初始热度',value: 26},
  {label: '删除帖子/文章',value: 27},
  // {label: '图片审核不通过下架帖子',value: 28},
  // {label: '帖子被举报超过阈值自动下架',value: 29},
  {label: '导出帖子',value: 30},
  {label: '导出帖子统计数据',value: 31},

  // Notice
  // {label: '管理员添加消息',value: 40},
  // {label: '管理员修改消息',value: 41},
  // {label: '管理员删除消息',value: 42},

  // User
  {label: '删除用户信息',value: 60},
  {label: '添加用户',value: 61},
  {label: '更新用户信息',value: 62},
  // {label: '修改个人信息',value: 63},
  {label: '修改密码',value: 64},

  // Comment
  {label: '评论被举报超过阈值自动下架', value: 80},

  // training
  {label: '删除培训', value: 81},
  {label: '新增培训', value: 82},
  {label: '编辑培训', value: 83},
  {label: '发布培训', value: 84},
  // {label: '重发培训', value: 85},
  {label: '下架培训', value: 86},
  {label: '邀请用户', value: 87},
  {label: '删除培训项目', value: 88},
  {label: '新增培训项目', value: 89},
  {label: '编辑培训项目', value: 90},
  {label: '填写培训项目问卷', value: 91},
  {label: '报名批准参与', value: 92},
  // {label: '报名优先排队', value: 93},
  {label: '排队成功', value: 94},
  {label: '排队失败', value: 95},
  {label: '报名拒绝参与', value: 96},
  {label: '删除报名', value: 97},
  {label: '导出已报名员工信息', value: 98},
  {label: '导出报名成功员工的签到信息', value: 99},
  {label: '群发信息', value: 100},
  {label: '导出培训统计数据', value: 104},
  {label: '发送课程提醒', value: 106},
  {label: '培训黑名单解除冻结', value: 107},
]